import * as React from "react"

const Sorting = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.5 37.29" {...props}>
    <title>{"parcel-journey-4-sorting-icon-2"}</title>
    <path
      fill="#ffffff"
      d="M6.6 0h16.04v16.04H6.6zM26.91 0h16.04v16.04H26.91zM47.22 0h16.04v16.04H47.22z"
    />
    <circle cx={9} cy={28.54} r={4.09} fill="#ffffff" />
    <path
      d="M26.35 24.45a4.1 4.1 0 1 0 4.09 4.11 4.09 4.09 0 0 0-4.09-4.11ZM43.7 24.45a4.1 4.1 0 1 0 4.09 4.11 4.1 4.1 0 0 0-4.09-4.11Z"
      fill="#ffffff"
    />
    <path
      d="M61.05 19.8h-52a8.75 8.75 0 0 0-.59 17.49h52.59a8.75 8.75 0 0 0 0-17.49Zm0 14.64h-52a5.9 5.9 0 0 1-.49-11.79h52.49a5.9 5.9 0 0 1 0 11.79Z"
      fill="#ffffff"
    />
    <circle cx={61.05} cy={28.54} r={4.09} fill="#ffffff" />
  </svg>
)

export default Sorting
